import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from '@edx/frontend-platform/i18n';
import { StandardModal } from '@openedx/paragon';

import useTranslationModal from './useTranslationModal';
import messages from './messages';
import './TranslationModal.scss';
import ModalFooter from './ModalFooter';
import UpgradeModalBody from './UpgradeModalBody';
import PaidModalBody from './PaidModalBody';

const TranslationModal = ({
  availableLanguages,
  isAuditMode,
  isFBE,
  isOpen,
  close,
  logEventProperties,
  selectedLanguage,
  setSelectedLanguage,
  verifiedMode,
  originalCourseLanguage,
}) => {
  const { formatMessage } = useIntl();
  const { currencySymbol, price, upgradeUrl } = verifiedMode;
  const {
    courseEnabledLanguages,
    selectedIndex,
    setSelectedIndex,
    onSubmit,
  } = useTranslationModal({
    selectedLanguage,
    setSelectedLanguage,
    close,
    isAuditMode,
    upgradeUrl,
    logEventProperties,
    availableLanguages,
    originalCourseLanguage,
  });

  const buttonText = isAuditMode ? (
    formatMessage(messages.upgradeButtonText, { upgradePrice: `${currencySymbol}${price}` })
  ) : (
    formatMessage(messages.submitButtonText)
  );

  const title = isAuditMode ? (
    formatMessage(messages.upgradeLanguageSelectionModalTitle, { asterisk: <sup>*</sup> })
  ) : (
    formatMessage(messages.languageSelectionModalTitle)
  );

  return (
    <StandardModal
      isOverflowVisible={false}
      title={title}
      isOpen={isOpen}
      onClose={close}
      isFullscreenScroll
      footerNode={(
        <ModalFooter
          {...{
            buttonText,
            onSubmit,
            close,
          }}
        />
      )}
    >
      {isAuditMode ? (
        <UpgradeModalBody {...{ courseEnabledLanguages, isFBE, originalCourseLanguage }} />
      ) : (
        <PaidModalBody
          {...{
            selectedIndex,
            setSelectedIndex,
            courseEnabledLanguages,
            originalCourseLanguage,
          }}
        />
      )}
    </StandardModal>
  );
};

TranslationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  selectedLanguage: PropTypes.string.isRequired,
  setSelectedLanguage: PropTypes.func.isRequired,
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isFBE: PropTypes.bool.isRequired,
  verifiedMode: PropTypes.shape({
    currencySymbol: PropTypes.string,
    price: PropTypes.number,
    upgradeUrl: PropTypes.string,
  }).isRequired,
  isAuditMode: PropTypes.bool.isRequired,
  logEventProperties: PropTypes.shape({
    org_key: PropTypes.string.isRequired,
    courserun_key: PropTypes.string.isRequired,
    course_name: PropTypes.string.isRequired,
  }).isRequired,
  originalCourseLanguage: PropTypes.string.isRequired,
};

export default TranslationModal;
